<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar dense dark tile flat class="title text-center text-md-right">
            What type of promotion are you requesting?
        </v-toolbar>
      </v-col>
      <v-col cols="12">
          <v-card color="grey lighten-3" flat>
              <i>Note: Requested forms of promotion must fit within the <router-link to="/Guidelines" class="accent--text">Mount Communication Policies</router-link> to be fulfilled.</i>
          </v-card>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Bulletin" value="bulletin"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Connect Center Table" value="connectTable"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Email Blast" value="email"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Paid Advertising" value="paidAdvertising"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Printed Materials" value="printedMaterials"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Screen Graphic" value="screenGraphic"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Stage Announcement" value="stageAnnouncement"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Social Media Post" value="socialMedia"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Video Announcement" value="vidAnnouncement"></v-checkbox>
      </v-col>
      <v-col sm="6" md="3">
        <v-checkbox color="secondary" dense v-model="event.promotion" label="Website/App Announcement" value="webApp"></v-checkbox>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-textarea
          v-model="event.staffAssistance"
          color="secondary"
          outlined
          label="List any other ways you are requesting staff assistance."
        >
        </v-textarea>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    eventInfo : Object
  },
  data(){
    return {
      event : this.eventInfo,
    }
  }
}
</script>

<style lang="css" scoped>
</style>
